const authenticate = async () => {
  const isAuthenticated =
    await window.asos?.sdk?.identity?.customer?.isAuthenticated();

  if (!isAuthenticated) {
    await window.asos.sdk.identity.login();
  }
};

export const runNativeWebViewUtil = async () => {
  const header = document?.getElementById("chrome-header");
  const footer = document?.getElementById("chrome-footer");
  const breadcrumb = document?.getElementById("chrome-breadcrumb");

  if (header) {
    header.style.display = "none";
  }

  if (footer) {
    footer.style.display = "none";
  }

  if (breadcrumb) {
    breadcrumb.style.display = "none";
  }

  if (typeof window === "undefined") {
    return;
  }

  try {
    await authenticate();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};
